import { SCENARIO_ID } from '@/context';

// Throttle the "enabling auto-refresh re-scrapes the page" confirmation to at
// most once per week per browser, scenario-scoped like the other KB flags.
const STORAGE_KEY = `__qc_autorefresh_warned_${SCENARIO_ID}`;
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

export const shouldShowAutoRefreshWarning = (): boolean => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw == null) return true;
  const shownAt = Number(raw);
  return !Number.isFinite(shownAt) || Date.now() - shownAt >= WEEK_MS;
};

export const markAutoRefreshWarningShown = (): void => {
  localStorage.setItem(STORAGE_KEY, String(Date.now()));
};
